import React, { createContext, useContext, useRef } from "react";

const ChatDialogContext = createContext(null);

export const useChatDialog = () => {
	const context = useContext(ChatDialogContext);
	if (!context) {
		throw new Error("useChatDialog must be used within ChatDialogProvider");
	}
	return context;
};

export const ChatDialogProvider = ({ children }) => {
	const chatDialogRef = useRef(null);

	const openChatWithMessage = async (message) => {
		if (chatDialogRef.current) {
			await chatDialogRef.current.openWithMessage(message);
		}
	};

	const openChat = () => {
		if (chatDialogRef.current) {
			chatDialogRef.current.open();
		}
	};

	return (
		<ChatDialogContext.Provider
			value={{
				openChatWithMessage,
				openChat,
				chatDialogRef,
			}}
		>
			{children}
		</ChatDialogContext.Provider>
	);
};

